import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide } from 'react-toastify';
import { useOktaAuth } from "@okta/okta-react";
import { oktaAuth } from "../config";
import Service from "../services/Service";
import Modal from 'react-modal';
import { customStylesModal } from '../global';

const storesModalStyles = {
    content: {
        "z-index": 6,
        top: '5%',
        right: '4vw',
        left: 'auto',
        bottom: 'auto',
        width: window.innerWidth > 1000 ? '500px' : '90%',
        height: 'min-content',
        maxHeight: '80vh',
        backgroundColor: 'white',
        overflow: 'auto',
    }
};

export default function UsersPage(props) {
    const [loading, setLoading] = useState(false);
    const { authState } = useOktaAuth();
    const [auth, setAuth] = useState(null)
    const [user, setUser] = useState(null)
    const [users, setUsers] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [pageSize] = useState(20)
    const [confirmDialog, setConfirmDialog] = useState(false)
    const [userToDelete, setUserToDelete] = useState(null)
    const [storesModal, setStoresModal] = useState(false)
    const [storesUser, setStoresUser] = useState(null)
    const [userStores, setUserStores] = useState([])
    const [newStoreJDA, setNewStoreJDA] = useState('')
    const [storesLoading, setStoresLoading] = useState(false)
    const loggingIn = async () => oktaAuth.signInWithRedirect({ originalUri: "/" });
    const service = new Service()

    useEffect(() => {
        let clear_url = window.location.href.split('/login')[0]
        if (clear_url)
            window.history.replaceState({ page: "display_page" }, "display_page", clear_url);
        if (localStorage.getItem('okta-token-storage') && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken) {
            setAuth('OK')
            service.getUser().then((data) => {
                setUser(data)
            }).catch((error) => {
                if (error.response.status == 401) {
                    if (error.response.data.code === "unauthorized") {
                        setAuth('notauth')
                    }
                    else if (error?.response?.data?.code === "missing_token") {
                        Promise.resolve(loggingIn())
                    }
                    else if (error.response.data.code === "expired_token") {
                        localStorage.setItem('refresh', true)
                        window.location.reload()
                    }
                }
            })
        }
        else if (!authState?.isAuthenticated) {
            if (!window.location.href.includes('code') && window.location.pathname && window.location.pathname.split('/').length > 0) {
                Promise.resolve(loggingIn())
            } else {
                setAuth('noauth')
            }
        }
    }, [])

    useEffect(() => {
        if (user && user.is_super_admin) {
            loadUsers()
        }
    }, [user, pageNumber])

    const loadUsers = () => {
        setLoading(true)
        service.getUsersList(pageNumber, pageSize).then((data) => {
            setUsers(data.users || data.Users || [])
            setTotalRecords(data.totalRecords || data.TotalRecords || 0)
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            toast.error(err.response?.data?.message || err.message || 'Error loading users', {
                transition: Slide,
                toastId: 'users_error'
            })
        })
    }

    const deleteUserConfirm = (userEmail) => {
        setUserToDelete(userEmail)
        setConfirmDialog(true)
    }

    const deleteUser = () => {
        if (!userToDelete) return

        service.deleteUser(userToDelete).then((response) => {
            setConfirmDialog(false)
            setUserToDelete(null)
            toast.success(response.message || 'User deleted successfully', {
                transition: Slide
            })
            loadUsers()
        }).catch((err) => {
            setConfirmDialog(false)
            toast.error(err.response?.data?.message || err.message || 'Error deleting user', {
                transition: Slide,
                toastId: 'delete_error'
            })
        })
    }

    const toggleAdmin = (userEmail, currentIsAdmin) => {
        const newIsAdmin = !currentIsAdmin
        service.setUserAdmin(userEmail, newIsAdmin).then((response) => {
            toast.success(response.message || (newIsAdmin ? 'User promoted to admin' : 'User demoted from admin'), {
                transition: Slide
            })
            loadUsers()
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error updating admin role', {
                transition: Slide,
                toastId: 'admin_error'
            })
        })
    }

    const openStoresModal = (userEmail) => {
        setStoresUser(userEmail)
        setStoresModal(true)
        setStoresLoading(true)
        setNewStoreJDA('')
        service.getUserStores(userEmail).then((data) => {
            setUserStores(data || [])
            setStoresLoading(false)
        }).catch((err) => {
            setStoresLoading(false)
            toast.error(err.response?.data?.message || err.message || 'Error loading stores', {
                transition: Slide,
                toastId: 'stores_error'
            })
        })
    }

    const addStore = () => {
        if (!newStoreJDA.trim() || !storesUser) return
        service.addUserVisibility(storesUser, newStoreJDA.trim()).then((response) => {
            toast.success(response.message || 'Store added successfully', { transition: Slide })
            setNewStoreJDA('')
            // Reload stores
            service.getUserStores(storesUser).then((data) => {
                setUserStores(data || [])
            })
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error adding store', {
                transition: Slide,
                toastId: 'add_store_error'
            })
        })
    }

    const removeStore = (jda) => {
        if (!storesUser) return
        service.removeUserVisibility(storesUser, jda).then((response) => {
            toast.success(response.message || 'Store removed successfully', { transition: Slide })
            // Reload stores
            service.getUserStores(storesUser).then((data) => {
                setUserStores(data || [])
            })
            loadUsers()
        }).catch((err) => {
            toast.error(err.response?.data?.message || err.message || 'Error removing store', {
                transition: Slide,
                toastId: 'remove_store_error'
            })
        })
    }

    const totalPages = Math.ceil(totalRecords / pageSize)

    const formatDateTime = (dateString) => {
        if (!dateString) return '-'
        const date = new Date(dateString)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }

    return (
        (loading ? '' : auth ? (auth == 'notauth' ? <div>
            <Navbar />
            <div Style={' height: calc(100vh - 70px);align-content: center;'}>
                <div className='label_text_bold center ' Style={'font-size:22px'}>Not authorized</div>
            </div>
        </div>
            :
            user && user.is_super_admin ?
                <div>
                    <Navbar />
                    <div className="flex subheader">
                        <div Style={'width:100%; padding: 20px;'}>
                            <div className='label_text_bold' Style={'font-size:22px; margin-bottom: 20px;'}>User Management</div>
                        </div>
                    </div>
                    {!loading ?
                        <div className="table-container">
                            <div className="table_container" Style={'height:calc(100vh - 225px); min-height:150px'}>
                                <table class="responsive-table mt0">
                                    <thead>
                                        <tr class="table-header">
                                            <th>Email</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>JDA</th>
                                            <th>Admin</th>
                                            <th>Super Admin</th>
                                            <th>Last Access</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users && users.length > 0 ? users.map((u) => (
                                            <tr key={u.email || u.Email}>
                                                <td><div className="mid">{u.email || u.Email}</div></td>
                                                <td><div className="mid">{u.firstName || u.FirstName || '-'}</div></td>
                                                <td><div className="mid">{u.lastName || u.LastName || '-'}</div></td>
                                                <td><div className="mid">{u.jda || u.JDA || '-'}</div></td>
                                                <td>
                                                    <div className="mid">
                                                        <label Style={'cursor: pointer; display: flex; align-items: center; gap: 5px;'}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!(u.isAdmin || u.IsAdmin || u.is_admin)}
                                                                onChange={() => toggleAdmin(u.email || u.Email, !!(u.isAdmin || u.IsAdmin || u.is_admin))}
                                                                Style={'cursor: pointer; width: 16px; height: 16px;'}
                                                            />
                                                        </label>
                                                    </div>
                                                </td>
                                                <td><div className="mid">{(u.isSuperAdmin || u.IsSuperAdmin || u.is_super_admin) ? 'Yes' : 'No'}</div></td>
                                                <td><div className="mid">{formatDateTime(u.lastAccessDate || u.LastAccessDate || u.last_access_date)}</div></td>
                                                <td>
                                                    <div className="mid" Style={'display: flex; gap: 10px; align-items: center;'}>
                                                        <button
                                                            className='submit-button'
                                                            onClick={() => openStoresModal(u.email || u.Email)}
                                                            Style={'font-size: 12px; padding: 4px 8px;'}
                                                        >
                                                            Manage Stores
                                                        </button>
                                                        <svg
                                                            onClick={() => deleteUserConfirm(u.email || u.Email)}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="20"
                                                            height="20"
                                                            fill="red"
                                                            class="bi bi-trash"
                                                            viewBox="0 0 16 16"
                                                            Style={'cursor: pointer;'}
                                                        >
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="8">
                                                    <div className="mid" Style={'padding: 20px;'}>No users found</div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {totalPages > 1 && (
                                    <div Style={'display: flex; justify-content: center; align-items: center; padding: 20px; gap: 10px;'}>
                                        <button
                                            className='cancel-button'
                                            onClick={() => setPageNumber(p => Math.max(1, p - 1))}
                                            disabled={pageNumber === 1}
                                            Style={pageNumber === 1 ? 'opacity: 0.5; cursor: not-allowed;' : ''}
                                        >
                                            Previous
                                        </button>
                                        <span className='label_text'>
                                            Page {pageNumber} of {totalPages} ({totalRecords} total users)
                                        </span>
                                        <button
                                            className='submit-button'
                                            onClick={() => setPageNumber(p => Math.min(totalPages, p + 1))}
                                            disabled={pageNumber === totalPages}
                                            Style={pageNumber === totalPages ? 'opacity: 0.5; cursor: not-allowed;' : ''}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        : <div className="loader-cont">
                            <div className="loader1"></div>
                        </div>}
                    {/* Delete Confirmation Modal */}
                    <Modal
                        ariaHideApp={false}
                        isOpen={confirmDialog}
                        onRequestClose={() => setConfirmDialog(false)}
                        style={customStylesModal}
                    >
                        <div className='modal_filters_container'>
                            <div>
                                <div className='filter-label-cont' Style={'text-align:center'}>Are you sure</div>
                                <svg onClick={() => setConfirmDialog(false)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor " class="bi bi-x close-button" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </div>
                            <hr className='separator' />
                            <div className='label_text center'>
                                You are about to delete the user: <strong>{userToDelete}</strong>
                            </div>
                            <div className="label_text_bold center">Do you want to proceed?</div>
                            <div className='flex_center mt-10' Style={'width:100%'}>
                                <button className='cancel-button' onClick={() => setConfirmDialog(false)}>Cancel</button>
                                <button className='submit-button' onClick={() => deleteUser()}>Delete</button>
                            </div>
                        </div>
                    </Modal>
                    {/* Store Management Modal */}
                    <Modal
                        ariaHideApp={false}
                        isOpen={storesModal}
                        onRequestClose={() => setStoresModal(false)}
                        style={storesModalStyles}
                    >
                        <div className='modal_filters_container'>
                            <div>
                                <div className='filter-label-cont' Style={'text-align:center'}>Manage Stores</div>
                                <svg onClick={() => setStoresModal(false)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor " class="bi bi-x close-button" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </div>
                            <hr className='separator' />
                            <div className='label_text' Style={'margin-bottom: 10px;'}>
                                Stores for: <strong>{storesUser}</strong>
                            </div>
                            {/* Add new store */}
                            <div Style={'display: flex; gap: 8px; margin-bottom: 15px; align-items: center;'}>
                                <input
                                    type="text"
                                    value={newStoreJDA}
                                    onChange={(e) => setNewStoreJDA(e.target.value)}
                                    placeholder="Enter JDA code"
                                    Style={'flex: 1; padding: 6px 10px; border: 1px solid #b6b6b6; border-radius: 5px;'}
                                    onKeyDown={(e) => { if (e.key === 'Enter') addStore() }}
                                />
                                <button className='submit-button' onClick={addStore} Style={'font-size: 12px; padding: 6px 12px;'}>
                                    Add
                                </button>
                            </div>
                            {/* Store list */}
                            {storesLoading ? (
                                <div Style={'text-align: center; padding: 20px;'}>Loading...</div>
                            ) : userStores.length > 0 ? (
                                <div Style={'max-height: 400px; overflow-y: auto;'}>
                                    <table class="responsive-table mt0" Style={'width: 100%;'}>
                                        <thead>
                                            <tr class="table-header">
                                                <th>JDA</th>
                                                <th>Name</th>
                                                <th>Country</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userStores.map((store) => (
                                                <tr key={store.jda || store.JDA}>
                                                    <td><div className="mid">{store.jda || store.JDA}</div></td>
                                                    <td><div className="mid">{store.name || store.Name || '-'}</div></td>
                                                    <td><div className="mid">{store.country || store.Country || '-'}</div></td>
                                                    <td>
                                                        <div className="mid">
                                                            <svg
                                                                onClick={() => removeStore(store.jda || store.JDA)}
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="red"
                                                                class="bi bi-trash"
                                                                viewBox="0 0 16 16"
                                                                Style={'cursor: pointer;'}
                                                            >
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                            </svg>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className='label_text center' Style={'padding: 20px;'}>No stores assigned</div>
                            )}
                        </div>
                    </Modal>
                    <ToastContainer stacked />
                </div>
                : <div>
                    <Navbar />
                    <div Style={' height: calc(100vh - 70px);align-content: center;'}>
                        <div className='label_text_bold center ' Style={'font-size:22px'}>Access restricted to super administrators only</div>
                    </div>
                </div>
        ) : ''))
}
